import { featureItems } from '@/mocks/darkwebData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="mb-10 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="text-foreground-600 text-sm mt-2">
            为什么选择51暗网作为你的暗网情报来源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center group hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-4 text-accent-600 text-xl">
                <i className={item.icon}></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}